import { getRampValues } from './helper';
export const getSpeedoSkin = (props) => {
    let rampValue = getRampValues(props);
    return {
        meter: {
            offsets: {
                tick: 6,
                tickLabel: 34,
                value: 0,
                pointer: 20,
                tickLabel: 40,
                tick: 15,
            },
            ramp: [
                { stop: Math.round((props.min / (props.max - props.min))), color: '#FF0000' },
                { stop: rampValue.highData, color: '#ffd700' },
                { stop: rampValue.mediumData, color: '#ffd700' },
                { stop: rampValue.lowData, color: '#00FF00' },
                // { stop: 1, color: '#00FF00' },
                /*{stop:1,color:'#F44336'} */
            ],
            colors: {
                background: 'white',
                label: '#FFFFFF',
                tickLabel: '#8286a3'
            },
            ticks: {
                major: {
                    count: 11
                },
                minor: {
                    count: 10,
                    width: 1
                },
                pointer: {
                    height: 80,
                    width: 8
                }
            },
            formatters: {
                value: function (v) { return (Math.round(v.toString())) },
                ideal: function (v) { return ""; },
                // tickLabel: (v) => typeof v === typeof undefined ? "" : `${v.toFixed(2).toString()}`
            },
            arc: {
                size: .8,
                width: 22
            }
        }
    };
};